import { UntypedFormGroup } from '@angular/forms';
import { DropdownOption } from 'src/app/components/common/common-dropdown/common-dropdown.component.model';
import {
  ContractorType,
  ContractorTypeRequirement
} from '../../../../models';
import {
  Activity,
  ActivityModel
} from 'src/app/models/activities';
import { DataEntity } from 'src/app/models/data-entities';

import { ConditionTarget } from 'src/app/components/system/condition-builder/condition-builder.model';
import { ItemTag } from 'src/app/models/item-tag';

export const EXPIRATION_MODES = {
  INFINITE: 'infinite',
  END_OF_YEAR: 'end-of-issue-year',
  CUSTOM_MONTHS: 'custom-months',
  CUSTOM_FORMULA: 'custom-formula'
};

export const EXPIRATION_OPTIONS: DropdownOption[] = [
  { value: EXPIRATION_MODES.INFINITE, label: 'Does not expire (infinite)' },
  { value: EXPIRATION_MODES.END_OF_YEAR, label: 'Expires at end of issued year' },
  { value: EXPIRATION_MODES.CUSTOM_MONTHS, label: 'Set a term length in months' },
  { value: EXPIRATION_MODES.CUSTOM_FORMULA, label: 'Calculate expiration date with custom formula' }
];

export const WORKFLOW_TYPES = {
  REGISTER: 'register',
  RENEWAL: 'renewal'
};

export interface NewContractorTypeState {
  form?: UntypedFormGroup;
  settingsForm?: UntypedFormGroup;

  saving: boolean;
  loadingData: boolean;
  isEditMode: boolean;

  fullEditingObject: ContractorType | null;

  registerWorkflowOptions: DropdownOption[];
  renewWorkflowOptions: DropdownOption[];
  expirationOptions: DropdownOption[];
  monthOptions: DropdownOption[];
  dayOptions: DropdownOption[];

  selectedExpirationValue: string;
  registerFixedNumberPreview: string;
  renewalFixedNumberPreview: string;

  contractorRequirements: ContractorTypeRequirement[];
  registrationRequirements: ContractorTypeRequirement[];
  contractorEntities: DataEntity[];
  availableContractorEntities: DataEntity[];
  registrationEntities: DataEntity[];
  availableRegistrationEntities: DataEntity[];
  newContractorRequirement: ContractorTypeRequirement | null;
  newRegistrationRequirement: ContractorTypeRequirement | null;

  registrationAutoVoidActivities: Activity<ActivityModel>[];
  renewalAutoVoidActivities: Activity<ActivityModel>[];
  registrationAutoVoidExample: string;
  renewalAutoVoidExample: string;

  customExpirationCriteria?: ConditionTarget[];
  contractorTypeTags: ItemTag[];
}

export const INITIAL_STATE: NewContractorTypeState = {
  saving: false,
  loadingData: true,
  isEditMode: false,
  fullEditingObject: null,
  registerWorkflowOptions: [],
  renewWorkflowOptions: [],

  expirationOptions: EXPIRATION_OPTIONS,

  monthOptions: [],
  dayOptions: [],
  selectedExpirationValue: EXPIRATION_MODES.INFINITE,
  registerFixedNumberPreview: '',
  renewalFixedNumberPreview: '',
  contractorRequirements: [],
  registrationRequirements: [],
  contractorEntities: [],
  availableContractorEntities: [],
  registrationEntities: [],
  availableRegistrationEntities: [],
  newContractorRequirement: null,
  newRegistrationRequirement: null,
  registrationAutoVoidActivities: [],
  renewalAutoVoidActivities: [],
  registrationAutoVoidExample: '',
  renewalAutoVoidExample: '',
  customExpirationCriteria: [],
  contractorTypeTags: []
};
